module.exports = __webpack_public_path__ + "static/media/img_give_back.c1376a8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_give_back.jpg
// module id = 809
// module chunks = 0